module.exports = __webpack_public_path__ + "static/media/track-project.b88cdf1b.svg";